import {
  GET_ALL_HIRING,
  GET_ALL_HIRING_SUCCESS,
  GET_ALL_HIRING_FAILURE,
  DELETE_SINGLE_HIRING,
  DELETE_SINGLE_HIRING_SUCCESS,
  DELETE_SINGLE_HIRING_FAILURE,
  GET_SINGLE_HIRING,
  GET_SINGLE_HIRING_SUCCESS,
  GET_SINGLE_HIRING_FAILURE,
} from "./actionTypes";

export const getAllHiring = () => {
  return {
    type: GET_ALL_HIRING,
  };
};
export const getAllHiringSuccess = (payload) => {
  return {
    type: GET_ALL_HIRING_SUCCESS,
    payload: payload,
  };
};

export const getAllHiringFailure = (error) => {
  return {
    type: GET_ALL_HIRING_FAILURE,
    payload: error,
  };
};

export const getSingleHiring = (payload) => {
  return {
    type: GET_SINGLE_HIRING,
    payload: payload,
  };
};
export const getSingleHiringSuccess = (payload) => {
  return {
    type: GET_SINGLE_HIRING_SUCCESS,
    payload: payload,
  };
};

export const getSingleHiringFailure = (error) => {
  return {
    type: GET_SINGLE_HIRING_FAILURE,
    payload: error,
  };
};

export const deleteSingleHiring = (id) => {
  return {
    type: DELETE_SINGLE_HIRING,
    payload: id,
  };
};

export const deleteSingleHiringSuccess = (id) => {
  return {
    type: DELETE_SINGLE_HIRING_SUCCESS,
    payload: id,
  };
};

export const deleteSingleHiringFailure = (error) => {
  return {
    type: DELETE_SINGLE_HIRING_FAILURE,
    payload: error,
  };
};
